import * as marietta from '../..';
import * as marietta3d from '../../../marietta3d';
import { AutoObjFitting } from '../../../marietta3d/AutoGen/object';
import { BUILDING_TYPE_MANSION } from '../Constants';
import { StartsQuotationList } from '../../../marietta3d/AutoGen/StartsQuotationList';

export default class CadAPIManager {
    callBackFuncMiniMapImage: Function;

    callBackFuncSunpousen: Function;

    callbackFuncGenerateFittings: Function;

    callbackFuncGenerateFittingsTargetAllFloor: boolean;

    callbackFuncGenerateEquipment: Function;

    callbackFuncGenerateEquipmentTargetAllFloor: boolean;

    /**
     * MiniMap画像の取得
     */

    getMiniMapImage(floor: number, imageWidth: number, imageHeight: number, imageFormat: number, callBack: Function = null) {
      this.callBackFuncMiniMapImage = callBack;

      const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
      marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);

      // measureLineData の取得
      // サーバ通信中･･･
      marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_CONNECTING'));
      marietta.webcad.WebCADGlobal.autoMain.requestSvgThumbnail(floor, imageWidth, imageHeight, imageFormat, 1/* Minmap image without room names */, marietta.webcad.WebCADGlobal.cadAPIManager.onGetMiniMapImage);

    }

    /**
    * MiniMap画像の取得後のアクション
    */
    onGetMiniMapImage = (data: any, msg: string = '') => {
      // APIからエラーメッセージが返ってきたらアラートを表示して終了
      if (msg !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(msg);
        return;
      }
      // do thing.
      marietta.webcad.WebCADGlobal.hideBusy();
      marietta.webcad.WebCADGlobal.cadAPIManager.callBackFuncMiniMapImage(data.image_binary_base64, msg);
    }

    /**
     * 寸法線の取得
     */

    getSunpousen = (callBack: Function = null) => {
      this.callBackFuncSunpousen = callBack;

      const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
      marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);

      // アイテム数のチェック
      const checkItemSize = marietta.webcad.WebCADGlobal.webcad2Dmanager.checkItemSize();
      if (checkItemSize !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(checkItemSize, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
      } else {
        marietta.webcad.WebCADGlobal.autoMain.requestAutoDimension(0, marietta.webcad.WebCADGlobal.cadAPIManager.onGetSunpousen);
      }
    }

    /**
    * 寸法線の取得後のアクション
    */
    onGetSunpousen = (measureLineDataList: marietta3d.AutoGen.object.AutoObjDimension[][], msg: string = '') => {
      // APIからエラーメッセージが返ってきたらアラートを表示して終了
      if (msg !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(msg);
        return;
      }
      marietta.webcad.WebCADGlobal.webcad2Dmanager.measureLineData = measureLineDataList;
      marietta.webcad.WebCADGlobal.hideBusy();

      marietta.webcad.WebCADGlobal.cadAPIManager.callBackFuncSunpousen();
      // if(this.callBackFuncSunpouen != null) this.callBackFuncSunpousen();
    }

    /**
    * 面積情報の取得
    */
    getMenseki = (callBack: Function = marietta.webcad.WebCADGlobal.showAreaInfoDialog) => {
      // サーバ通信中･･･
      marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_CONNECTING'));

      // アイテム数のチェック
      const checkItemSize = marietta.webcad.WebCADGlobal.webcad2Dmanager.checkItemSize();
      const data: marietta.webcad.collection.AreaDataCollection = new marietta.webcad.collection.AreaDataCollection();

      function cb(dataFrom3d: marietta3d.AutoGen.PlanAreaInfo, msg: string = '') {
        // APIからエラーメッセージが返ってきたらアラートを表示して終了
        if (msg !== '') {
          marietta.webcad.WebCADGlobal.hideBusy();
          marietta.webcad.WebCADGlobal.showAlert(msg);
        } else {
          data.importFromPlanAreaInfo(dataFrom3d);
          marietta.webcad.WebCADGlobal.hideBusy();

          // マネージャーにデータ渡す
          marietta.webcad.WebCADGlobal.webcad2Dmanager.areaData = data;

          // コールバック
          if (callBack != null) {
            callBack();
          }
        }
      }

      if (checkItemSize !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(checkItemSize, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
      } else {
        const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
        // 3D側にJSON受け渡し
        marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);

        marietta.webcad.WebCADGlobal.autoMain.requestPlanArea(cb);
      }
    }

    /**
     * 建具の自動生成
     * @param targetAllFloor:boolean 表示中のフロアだけか、全フロアを対象にするか
     */
    // eslint-disable-next-line consistent-return
    generateFittings=(cb?: Function, targetAllFloor: boolean = false): boolean => {
      this.callbackFuncGenerateFittings = cb;
      this.callbackFuncGenerateFittingsTargetAllFloor = targetAllFloor;
      // サーバ通信中･･･
      marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_CONNECTING'));
      // アイテム数のチェック
      const checkItemSize = marietta.webcad.WebCADGlobal.webcad2Dmanager.checkItemSize();
      if (checkItemSize !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(checkItemSize, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
        return false;
      }

      // 建具の初期化
      marietta.webcad.WebCADGlobal.layerGroup.initFittingLayers(targetAllFloor);
      const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
      const self = this;
      marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);
      marietta.webcad.WebCADGlobal.autoMain.requestFittingGen(self.onGetGenerateFittings);
    }

    /**
    * 建具の自動生成 受け取り
    */
    onGetGenerateFittings = (dataFromAPI: Array<Array<AutoObjFitting>>, msg: string = '') => {
      marietta.webcad.WebCADGlobal.hideBusy();

      // APIからエラーメッセージが返ってきたらアラートを表示して終了
      if (msg !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(msg);
        return;
      }

      // Itemnanger.createItem(）でMakeRoomWall API呼び出しを処理するために使用されます。
      marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = true;
      // 建具の生成
      let info: marietta.webcad.collection.ItemInfoCollection;
      for (let k: number = 0; k < dataFromAPI.length; k += 1) {
        if (!(!this.callbackFuncGenerateFittingsTargetAllFloor && (k !== marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor - 1))) {
          for (let i: number = 0; i < dataFromAPI[k].length; i += 1) {
            info = new marietta.webcad.collection.ItemInfoCollection();
            info.floor = dataFromAPI[k][i].flr;
            info.id = dataFromAPI[k][i].item;
            info.rotation = dataFromAPI[k][i].rotation;
            info.width = dataFromAPI[k][i].width;
            info.lr = dataFromAPI[k][i].reverse;
            info.x = dataFromAPI[k][i].p.x;
            info.y = -(dataFromAPI[k][i].p.y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H);
            info.z = 0;
            info.height = 0;
            info.guid = marietta.webcad.WebCADGlobal.getGuid();

            try {
              if (info.id === 'fit02_01') {
                marietta.webcad.WebCADGlobal.webcad2Dmanager.UpdateRoomWallWithFitting(info);
              } else {
                const newItem = marietta.webcad.WebCADGlobal.itemManager.createItem(info);
                if (newItem instanceof marietta.webcad.item.Fitting) {
                  newItem.snapToWall(false);
                }
              }
            } catch (error) {
              console.log(`import error:${info.id}`);
            }
          }
        }
      }
      if (this.callbackFuncGenerateFittings) {
        this.callbackFuncGenerateFittings();
        this.callbackFuncGenerateFittings = null;
      }
      // reset value
      marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }

    /**
     * 住宅設備の自動生成
     * @param targetAllFloor:boolean 表示中のフロアだけか、全フロアを対象にするか
     */
    generateEquipment=(cb?: Function, targetAllFloor: boolean = false) => {
      this.callbackFuncGenerateEquipment = cb;
      this.callbackFuncGenerateEquipmentTargetAllFloor = targetAllFloor;
      // サーバ通信中･･･
      marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_CONNECTING'));
      // アイテム数のチェック
      const checkItemSize = marietta.webcad.WebCADGlobal.webcad2Dmanager.checkItemSize();
      if (checkItemSize !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(checkItemSize, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
      } else {
        // 建具の初期化
        marietta.webcad.WebCADGlobal.layerGroup.initEquipmentLayers(targetAllFloor);

        const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
        const self = this;
        // 3D側にXML受け渡し
        marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);
        marietta.webcad.WebCADGlobal.autoMain.requestEquipmentGen(self.onGetGenerateEquipment);
      }
    }

    /**
     * 住宅設備の自動生成 受け取り
     */
    onGetGenerateEquipment = (dataFromAPI: Array<Array<marietta3d.AutoGen.object.AutoObjEquipment>>, msg: string = '') => {
      marietta.webcad.WebCADGlobal.hideBusy();

      console.log(dataFromAPI);

      // APIからエラーメッセージが返ってきたらアラートを表示して終了
      if (msg !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(msg);
        return;
      }

      // 住宅設備の生成
      let info: marietta.webcad.collection.ItemInfoCollection;
      for (let k: number = 0; k < dataFromAPI.length; k += 1) {
        if (!(!this.callbackFuncGenerateEquipmentTargetAllFloor && (k !== marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor - 1))) {
          for (let i: number = 0; i < dataFromAPI[k].length; i += 1) {
            info = new marietta.webcad.collection.ItemInfoCollection();
            info.floor = dataFromAPI[k][i].flr;
            info.id = dataFromAPI[k][i].item;
            info.rotation = dataFromAPI[k][i].rotation;
            if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
              info.widthmm = dataFromAPI[k][i].width;
              info.heightmm = dataFromAPI[k][i].depth;
            } else {
              info.widthmm = marietta.webcad.util.WebCADUtil.convertPixToMM(dataFromAPI[k][i].width);
              info.heightmm = marietta.webcad.util.WebCADUtil.convertPixToMM(dataFromAPI[k][i].depth);
            }

            info.lr = dataFromAPI[k][i].reverse;
            info.x = dataFromAPI[k][i].p.x;
            info.y = -(dataFromAPI[k][i].p.y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H);
            info.z = 0;
            info.guid = marietta.webcad.WebCADGlobal.getGuid();

            try {
              marietta.webcad.WebCADGlobal.itemManager.createItem(info);
            } catch (error) {
              console.log(`import error:${info.id}`);
            }
          }
        }
      }
      if (this.callbackFuncGenerateEquipment) {
        this.callbackFuncGenerateEquipment();
        this.callbackFuncGenerateEquipment = null;
      }
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }

    /**
     * 部屋結合
     * */
    joinRooms = (): void => {
      const rooms = marietta.webcad.WebCADGlobal.itemManager.getSelectedRoomsForJoin();

      if (rooms == null || rooms.length !== 2) {
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_SELECT2_ROOMS'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
        return;
      }
      if (rooms[0].itemInfo.lock || rooms[1].itemInfo.lock) {
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_JOIN_ROOMS'));
        return;
      }

      // '計算中･･･'
      marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_CALCULATING'));

      const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
      // 3D側にJSON受け渡し
      marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);
      const room1: marietta.webcad.item.MonicaObject = rooms[0] as marietta.webcad.item.MonicaObject;
      const room2: marietta.webcad.item.MonicaObject = rooms[1] as marietta.webcad.item.MonicaObject;
      const itemInfo: marietta.webcad.collection.ItemInfoCollection = room1.itemInfo.clone();
      const dataFromAPI: marietta3d.AutoGen.utils.RoomPointArray = marietta.webcad.WebCADGlobal.autoMain.MargeRoom(room1.itemInfo.floor, room1.itemInfo.guid, room2.itemInfo.guid);

      // 成立しない場合
      if (dataFromAPI == null) {
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_JOIN_ROOMS'));
        marietta.webcad.WebCADGlobal.hideBusy();
        return;
      }

      // お部屋を削除
      room1.deleteMe();
      room2.deleteMe();

      // 頂点情報の作成
      const roomConfig: marietta.webcad.collection.RoomConfigCollection = marietta.webcad.WebCADGlobal.getRoomConfig(itemInfo.id);
      itemInfo.dotList = [];
      itemInfo.x = 0;
      itemInfo.y = 0;
      for (let i: number = 0; i < dataFromAPI.length; i += 1) {
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          itemInfo.dotList.push(new marietta.webcad.collection.PointCollection(marietta.webcad.util.WebCADUtil.convertMMToPix(dataFromAPI[i].x), marietta.webcad.util.WebCADUtil.convertMMToPix(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - dataFromAPI[i].y), roomConfig.wallType));
        } else {
          itemInfo.dotList.push(new marietta.webcad.collection.PointCollection(dataFromAPI[i].x, -dataFromAPI[i].y + marietta.webcad.WebCADGlobal.LAYER_SIZE_H, roomConfig.wallType));
        }
      }

      const p = new Promise((resolve: Function) => {
        // 生成
        marietta.webcad.WebCADGlobal.itemManager.createItem(itemInfo, resolve);
      });
      // アイテム生成完了後にヒストリに保管
      p.then(() => {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
      }).catch((msg: any) => {
        console.log(msg);
      });

      marietta.webcad.WebCADGlobal.hideBusy();
    }

    /**
     * 建具手動生成
     * */
    createFittingFromPoint = (point1: marietta.core.Point, point2: marietta.core.Point): void => {
      marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_CALCULATING'));

      const { currentFloor } = marietta.webcad.WebCADGlobal.webcad2Dmanager;
      const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
      // 3D側にJSON受け渡し
      marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);
      let p1 = new marietta.core.Point(point1.x, -(point1.y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H), 0);
      let p2 = new marietta.core.Point(point2.x, -(point2.y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H), 0);
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
        p1 = new marietta.core.Point(marietta.webcad.util.WebCADUtil.convertPixToMM(point1.x), -(marietta.webcad.util.WebCADUtil.convertPixToMM(point1.y) - marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H)), 0);
        p2 = new marietta.core.Point(marietta.webcad.util.WebCADUtil.convertPixToMM(point2.x), -(marietta.webcad.util.WebCADUtil.convertPixToMM(point2.y) - marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H)), 0);
      }
      let retInfo: { item: string, x: number, y: number, angle: number, width: number };
      try {
        retInfo = marietta.webcad.WebCADGlobal.autoMain.semiAutoFittingGen(currentFloor, p1, p2);
      } catch (error) {
        // エラーが発生したら何もしないで停止
        marietta.webcad.WebCADGlobal.hideBusy();
        return;
      }

      if (retInfo == null) {
        marietta.webcad.WebCADGlobal.hideBusy();
        return;
      }

      // 生成できない場合は、アラートを出して終了
      if (!retInfo.item || retInfo.item == null) {
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_NO_FITTINGFITS'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));

        // BUSY停止
        marietta.webcad.WebCADGlobal.hideBusy();
        return;
      }

      // 建具を生成する
      const itemInfo: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
      itemInfo.id = retInfo.item;
      itemInfo.x = retInfo.x;
      itemInfo.y = -(retInfo.y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H);
      itemInfo.width = retInfo.width;
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
        itemInfo.x = marietta.webcad.util.WebCADUtil.convertMMToPix(retInfo.x);
        itemInfo.y = marietta.webcad.util.WebCADUtil.convertMMToPix(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - (retInfo.y));
        itemInfo.width = marietta.webcad.util.WebCADUtil.convertMMToPix(retInfo.width);
      }
      itemInfo.rotation = retInfo.angle;
      itemInfo.guid = marietta.webcad.WebCADGlobal.getGuid();

      // 生成
      const newItem = marietta.webcad.WebCADGlobal.itemManager.createItem(itemInfo);
      if (newItem instanceof marietta.webcad.item.Fitting) {
        newItem.snapToWall(false);
      }

      // BUSY停止
      marietta.webcad.WebCADGlobal.hideBusy();
    }

    // 廊下の自動生成コールバック
    checkAutoHallwaysCallBack: Function;

    /**
     * 廊下自動生成の判別
     * @param {Function} cb
     * @memberof CadAPIManager
     */
    checkAutoHallways(cb: Function) {
      this.checkAutoHallwaysCallBack = cb;
      // ビジー画面表示
      marietta.webcad.WebCADGlobal.showBusy('廊下をチェック');
      const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
      // 3D側にJSON受け渡し
      marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);
      marietta.webcad.WebCADGlobal.autoMain.checkAutoHallway(this.onCheckAutoHallways);
    }

    /**
     * 廊下自動生成の判別がされた
     */
    onCheckAutoHallways = (value: boolean) => {
      marietta.webcad.WebCADGlobal.hideBusy();

      // コールバック実行
      if (value) {
        marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ConfirmGenerateHallwayDialog2);
      } else {
        this.checkAutoHallwaysCallBack();
      }
    }

    // 廊下起動生成コールバック
    callbackFuncGenerateHallways: Function;

    callbackFuncGenerateHallwaysTargetAllFloor: boolean;

    /**
     * 廊下の自動生成
     * @param targetAllFloor:boolean 表示中のフロアだけか、全フロアを対象にするか
     */
    generateHallways = (cb?: Function, targetAllFloor: boolean = false) => {
      this.callbackFuncGenerateHallways = cb;
      this.callbackFuncGenerateHallwaysTargetAllFloor = targetAllFloor;
      // サーバ通信中･･･
      marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_CONNECTING'));

      // アイテム数のチェック
      const checkItemSize = marietta.webcad.WebCADGlobal.webcad2Dmanager.checkItemSize();
      if (checkItemSize !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(checkItemSize, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
      } else {
        // 廊下の初期化
        marietta.webcad.WebCADGlobal.layerGroup.initRoomdownLayers(targetAllFloor);

        const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
        // 3D側にJSON受け渡し
        marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);
        marietta.webcad.WebCADGlobal.autoMain.requestAutoHallway(null, this.onGetGenerateHallways);
      }
    }

    /**
     * 廊下の自動生成 受け取り
     */
    onGetGenerateHallways = (dataFromAPI: Array<Array<marietta3d.AutoGen.utils.RoomPointArray>>, msg: string = '') => {
      // APIからエラーメッセージが返ってきたらアラートを表示して終了
      if (msg !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(msg);
        return;
      }

      console.log(dataFromAPI);
      marietta.webcad.WebCADGlobal.hideBusy();
      dataFromAPI.forEach((roomPointArrays, index) => {
        if (!marietta.webcad.WebCADGlobal.cadAPIManager.callbackFuncGenerateHallwaysTargetAllFloor && (index !== marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor - 1)) return;
        // 建具の生成
        const flr = index + 1;
        const roomPointArraysCopy = [];
        roomPointArrays.forEach((roomPointArray: marietta3d.AutoGen.utils.RoomPointArray) => {
          const roomPointArr = new marietta3d.AutoGen.utils.RoomPointArray();
          roomPointArr.CopyFrom(roomPointArray);
          roomPointArraysCopy.push(roomPointArr);
        });
        roomPointArraysCopy.forEach((roomPointArray) => {
          const info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();

          info.floor = flr;
          info.id = 'rom02_01';
          info.dotList = [];
          info.x = 0;
          info.y = 0;
          for (let k: number = 0; k < roomPointArray.length; k += 1) {
            const point = new marietta.webcad.collection.PointCollection(roomPointArray[k].x, -(roomPointArray[k].y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H), roomPointArray[k].flag);
            info.dotList.push(point);
          }
          try {
            marietta.webcad.WebCADGlobal.itemManager.createItem(info);
          } catch (error) {
            console.error(error);
            console.log(`import error:${info.id}`);
          }
        });
      });

      if (this.callbackFuncGenerateHallways) {
        this.callbackFuncGenerateHallways();
        this.callbackFuncGenerateHallways = null;
      }
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }

    /**
     * 離れた部屋があるか否かのチェック
     * @param function コールバック関数
     */
    apiHasSeperatedRoom=(cb: Function) => {
      const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
      // 3D側にJSON受け渡し
      marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);

      marietta.webcad.WebCADGlobal.autoMain.RequestOutDivideCheck(cb);
    }

    /**
     * 屋根形状の取得
     */
    isRoofBusy: boolean;

    callBackFuncRoof: Function;

    callBackFuncRoofError: Function;

    targetFloorsForRoof: number[];

    /**
   * 屋根形状の取得
   *
   * @param {Function} callBack
   * @param {Function} callBackError
   * @param {boolean} [isAll=false]
   * @returns
   * @memberof CadAPIManager
   */
    getRoof(callBack: Function, callBackError: Function, isAll: boolean = false) {
      if (this.isRoofBusy) return;

      this.isRoofBusy = true;
      this.callBackFuncRoof = callBack;
      this.callBackFuncRoofError = callBackError;

      if (isAll) {
        this.targetFloorsForRoof = [1, 2, 3];
      } else {
        this.targetFloorsForRoof = [];
        this.targetFloorsForRoof.push(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor);
      }

      const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
      // 3D側にJSON受け渡し
      marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);

      // measureLineData の取得
      // サーバ通信中･･･
      marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_CONNECTING'));

      // アイテム数のチェック
      const checkItemSize = marietta.webcad.WebCADGlobal.webcad2Dmanager.checkItemSize();
      if (checkItemSize !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(checkItemSize, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
      } else {
        marietta.webcad.WebCADGlobal.autoMain.requestAutoRoof(marietta.webcad.WebCADGlobal.cadAPIManager.onGetRoof);
      }
    }

    /**
    * 屋根データの取得完了
    */
    onGetRoof = (roofDataList: marietta3d.AutoGen.object.AutoObjRoof[][], msg: string = '') => {
      const self = this;

      self.isRoofBusy = false;
      // APIからエラーメッセージが返ってきたらアラートを表示して終了
      if (msg !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(msg);

        self.callBackFuncRoofError();
        return;
      }
      // 屋根の生成
      let tarIndex;
      const dataList = [];
      for (let i = 0; i < self.targetFloorsForRoof.length; i += 1) {
        tarIndex = self.targetFloorsForRoof[i] - 1;
        dataList.push(roofDataList[tarIndex]);
      }

      marietta.webcad.WebCADGlobal.hideBusy();
      self.callBackFuncRoof(dataList);
    }

    /**
    * 積算情報の取得
    */
    getSekisanInfo=(callBack: Function = marietta.webcad.WebCADGlobal.showSekisanInfoDialog) => {
      // サーバ通信中･･･
      marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_CONNECTING'));

      // アイテム数のチェック
      const checkItemSize = marietta.webcad.WebCADGlobal.webcad2Dmanager.checkItemSize();
      function cb(dataFrom3d: marietta3d.AutoGen.PlanEstimate, msg: string = '') {
        // APIからエラーメッセージが返ってきたらアラートを表示して終了
        if (msg !== '') {
          marietta.webcad.WebCADGlobal.hideBusy();
          marietta.webcad.WebCADGlobal.showAlert(msg);
          return;
        }
        marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData = dataFrom3d;
        marietta.webcad.WebCADGlobal.hideBusy();
        // コールバック
        if (callBack != null) {
          callBack();
        }
      }
      if (checkItemSize !== '') {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(checkItemSize, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
      } else {
        const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
        // 3D側にJSON受け渡し
        marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);

        marietta.webcad.WebCADGlobal.autoMain.requestEstimate(cb);
      }
    }

    /**
     * 壁リストを取得
     */
    callbackFuncRoomCut;

    MakeRoomWall=() => { // , targetAllFloor: boolean = false
      this.callbackFuncRoomCut = (newRoomJson: any) => {
        if (newRoomJson != null) {
          // 全部屋を包絡した状態で再配置
          (marietta.webcad.WebCADGlobal.webcad2Dmanager).createRoomWallPoints(newRoomJson.wall, newRoomJson.building_type);
        }
      };

      // アイテム数のチェック
      const checkItemSize = marietta.webcad.WebCADGlobal.webcad2Dmanager.checkItemSize();
      if (checkItemSize !== '') {
        marietta.webcad.WebCADGlobal.showAlert(checkItemSize, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
      } else {
        const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
        marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);
        marietta.webcad.WebCADGlobal.autoMain.RequestMakeRoomWall(this.callbackFuncRoomCut);
      }
    }

  /**
   * 積算情報の取得
   * Busy を出さない要求（仕様情報の自動の作り直し）は、エラーをアラートにせず失敗の表示だけにする。isLatest が false の応答は表示を変えない
   */
  public getStartsQuotationInfo = (callBack: Function, withBusy: boolean, isLatest: () => boolean = () => true): void => {
    const LOADING_ID: string = 'indicationLoadingEstimate';
    const ERROR_ID: string = 'indicationErrorEstimate';
    /** 失敗の表示は CSS で隠しているので、出すときは display を指定する */
    const ERROR_DISPLAY: string = 'inline';
    //計算中の表示
    (<HTMLElement>document.getElementById(LOADING_ID)).style.removeProperty('display');
    (<HTMLElement>document.getElementById(ERROR_ID)).style.display = 'none';

    // サーバ通信中･･･
    if (withBusy)marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_CONNECTING'));

    // アイテム数のチェック
    const checkItemSize = marietta.webcad.WebCADGlobal.webcad2Dmanager.checkItemSize();

    /** 失敗しましたの表示にする。ユーザーが押した要求（Busy あり）だけ、理由をアラートで出す */
    function showError(msg: string, title: string = ''): void {
      if (withBusy) marietta.webcad.WebCADGlobal.showAlert(msg, title);
      (<HTMLElement>document.getElementById(ERROR_ID)).style.display = ERROR_DISPLAY;
      (<HTMLElement>document.getElementById(LOADING_ID)).style.display = 'none';
    }

    function cb(dataFromApi:StartsQuotationList, msg: string = '') {
      if(withBusy)marietta.webcad.WebCADGlobal.hideBusy();
      // 後から出した要求がある古い応答は、その要求の「計算中」を消さないよう表示に触らない
      if (!isLatest()) return;

      // APIからエラーメッセージが返ってきたら失敗の表示にして終了
      if (msg !== '') {
        showError(msg);
        return;
      }

      console.log(dataFromApi);

      //計算中の表示
      (<HTMLElement>document.getElementById(LOADING_ID)).style.display = 'none';

      // コールバック
      if (callBack != null) {
        callBack(dataFromApi);
      }
    }
    if (checkItemSize !== '') {
      if(withBusy)marietta.webcad.WebCADGlobal.hideBusy();
      showError(checkItemSize, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
    } else {
      // const json: any = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
      // // 3D側にJSON受け渡し
      // marietta.webcad.WebCADGlobal.autoMain.parseJSON(json);
      //
      marietta.webcad.WebCADGlobal.autoMain.requestStartsQuotationList(cb);
    }
  }
}
